<template>
    <div class="circle-item">
        <img class="circle-out" src="../../../assets/newscreen/circle_b.png" alt="">
        <img src="../../../assets/newscreen/circle_s.png" alt="" class="circle-in">
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
.circle-item {
    position: relative;
    height: 11vh;
    overflow: hidden;
    .circle-out {
        width: 11vh;
        height: 11vh;
        animation: round 2s linear infinite;
    }
    .circle-in {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 9vh;
        height: 9vh;
    }
    .content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #fff;
    }
}

@keyframes round {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

</style>